import {FeatureFlags, isEnvFlagType} from './types';

const FEATURE_FLAG_PREFIX = 'VITE_FEATURE_TOGGLE__';
const LOCAL_FEATURE_FLAG_PREFIX = 'FEATURE_TOGGLE__';
const convertToPropName = (key: string) => key.slice(FEATURE_FLAG_PREFIX.length);

const extractEnvFeatureFlags = () =>
  Object.keys(import.meta.env)
    .filter(key => key.startsWith(FEATURE_FLAG_PREFIX))
    .map(key => [convertToPropName(key), import.meta.env[key] === 'true'] as const)
    .reduce((result: FeatureFlags, [key, value]) => {
      if (isEnvFlagType(key)) {
        result[key] = value;
      }
      return result;
    }, {});

const extractLocalFeatureFlag = (flag: keyof FeatureFlags) => {
  try {
    const featureFlag = localStorage.getItem(`${LOCAL_FEATURE_FLAG_PREFIX}${flag}`);
    return featureFlag ? JSON.parse(featureFlag) : undefined;
  } catch {
    return undefined;
  }
};

let featureFlags: FeatureFlags = extractEnvFeatureFlags();
export function setFeatureFlags(newFeatureFlags: FeatureFlags = {}) {
  featureFlags = {...featureFlags, ...newFeatureFlags};
}

export function getFeatureFlags(flag: keyof FeatureFlags) {
  const localFeatureFlag = extractLocalFeatureFlag(flag);
  return localFeatureFlag !== undefined ? localFeatureFlag : featureFlags[flag];
}
